import React from "react";
import { BsTelephoneFill, BsEnvelopeFill } from "react-icons/bs";

import {
  FaFacebookSquare,
  FaYoutubeSquare,
  FaInstagramSquare,
  FaLinkedin,
} from "react-icons/fa";

const TopHeader = () => {
  return (
    <div className="w-full h-auto">
      <div className="bg-banner-background h-auto bg-no-repeat bg-cover w-full">
        <div className="w-full h-full bg-primeColor bg-opacity-60">
          <div className="max-w-screen-2xl mx-auto">
            <div className="w-full bg-transparent text-white flex flex-col md:flex-row md:justify-between px-4 items-center py-1 gap-2 md:gap-0">
              <div className="font-bodyFont text-[14px] w-full flex flex-col md:flex-row items-center gap-0 md:gap-6">
                <p className="flex justify-start items-center gap-2">
                  <span>
                    <BsTelephoneFill />
                  </span>
                  +88 01975598780
                </p>
                <p className="flex justify-start items-center gap-2">
                  <span>
                    <BsEnvelopeFill />
                  </span>
                  <a href="mailto:query.educare@gmail.com">
                    query.educare@gmail.com
                  </a>
                </p>
              </div>
              <div className="w-auto hidden md:flex justify-center">
                <ul className="flex justify-start items-center text-xl gap-4">
                  <li className="hover:scale-125 transition-hover duration-300 cursor-pointer">
                    <a
                      href="https://www.facebook.com/educareenglishlearningacademy/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaFacebookSquare className="rounded-lg" />
                    </a>
                  </li>
                  <li className="hover:scale-125 transition-hover duration-300 cursor-pointer">
                    <a
                      href="https:www.youtube.com/channel/UCcci_0jFRNEVQSBXTgyodZA/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaYoutubeSquare className="rounded-lg " />
                    </a>
                  </li>
                  <li className="hover:scale-125 transition-hover duration-300 cursor-pointer">
                    <a
                      href="https://instagram.com/educare_englishlearningacademy?igshid=YmMyMTA2M2Y="
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaInstagramSquare className="rounded-lg" />
                    </a>
                  </li>
                  <li className="hover:scale-125 transition-hover duration-300 cursor-pointer">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.linkedin.com/company/educare-english-learning-academy/"
                    >
                      <FaLinkedin className="rounded-lg" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
